import React from 'react';
import { CTAButton } from './CTAButton';
export function ValueStackSection() {
  return <section className="w-full bg-pink-dark py-14 md:py-20 px-4" data-id="element-444">
      <div className="max-w-[680px] mx-auto" data-id="element-445">
        <h2 className="font-heading font-bold text-3xl md:text-4xl text-white text-center mb-12" data-id="element-446">
          Resumen de Todo lo que Recibís Hoy
        </h2>

        <div className="bg-white rounded-3xl overflow-hidden shadow-2xl" data-id="element-447">
          <div className="p-5 sm:p-8 md:p-10" data-id="element-448">
            <div className="font-body" data-id="element-449">
              {/* Bonus items */}
              <div className="space-y-0" data-id="element-450">
                <div className="flex justify-between items-center py-4 border-b border-gray-100" data-id="element-451">
                  <span className="text-dark-gray font-medium text-sm sm:text-base pr-4" data-id="element-452">
                    1. Kit "Compra Cero Estrés"
                  </span>
                  <span className="text-medium-gray line-through text-sm sm:text-base flex-shrink-0" data-id="element-453">
                    $9.40
                  </span>
                </div>
                <div className="flex justify-between items-center py-4 border-b border-gray-100" data-id="element-454">
                  <span className="text-dark-gray font-medium text-sm sm:text-base pr-4" data-id="element-455">
                    2. Guía "Talle Real"
                  </span>
                  <span className="text-medium-gray line-through text-sm sm:text-base flex-shrink-0" data-id="element-456">
                    $9.40
                  </span>
                </div>
                <div className="flex justify-between items-center py-4 border-b border-gray-100" data-id="element-457">
                  <span className="text-dark-gray font-medium text-sm sm:text-base pr-4" data-id="element-458">
                    3. Checklist "24 Horas Sin Trabarte"
                  </span>
                  <span className="text-medium-gray line-through text-sm sm:text-base flex-shrink-0" data-id="element-459">
                    $9.40
                  </span>
                </div>
                <div className="flex justify-between items-center py-4 border-b border-gray-100" data-id="element-460">
                  <span className="text-dark-gray font-medium text-sm sm:text-base pr-4" data-id="element-461">
                    4. Pack "Textos que Venden"
                  </span>
                  <span className="text-medium-gray line-through text-sm sm:text-base flex-shrink-0" data-id="element-462">
                    $9.40
                  </span>
                </div>
                <div className="flex justify-between items-center py-4 border-b border-gray-100" data-id="element-463">
                  <span className="text-dark-gray font-medium text-sm sm:text-base pr-4" data-id="element-464">
                    5. Mini Guía "Acabado Pro"
                  </span>
                  <span className="text-medium-gray line-through text-sm sm:text-base flex-shrink-0" data-id="element-465">
                    $9.40
                  </span>
                </div>
              </div>

              {/* Totals */}
              <div className="flex justify-between items-center pt-5 pb-3" data-id="element-466">
                <span className="text-dark-gray font-bold text-base sm:text-lg" data-id="element-467">
                  TOTAL BONOS
                </span>
                <div className="flex items-center gap-2" data-id="element-468">
                  <span className="text-medium-gray text-base sm:text-lg line-through" data-id="element-469">
                    $47
                  </span>
                  <span className="text-pink-dark font-bold text-base sm:text-lg" data-id="element-470">
                    HOY GRATIS
                  </span>
                </div>
              </div>

              <div className="flex justify-between items-center py-3 border-t border-gray-100" data-id="element-471">
                <span className="text-dark-gray font-bold text-base sm:text-lg" data-id="element-472">
                  Guía "Bikinis al Crochet"
                </span>
                <div className="flex items-center gap-2" data-id="element-473">
                  <span className="text-medium-gray text-sm line-through" data-id="element-474">
                    $19,99
                  </span>
                  <span className="text-pink-dark font-bold text-base sm:text-lg" data-id="element-475">
                    $14
                  </span>
                </div>
              </div>

              {/* Pagas hoy - highlighted */}
              <div className="mt-6 bg-beige rounded-2xl p-6 md:p-8 border-2 border-pink-light text-center" data-id="element-476">
                <p className="font-body text-medium-gray text-sm mb-1" data-id="element-477">
                  Valor total: <span className="line-through" data-id="element-478">$66,99</span>
                </p>
                <p className="font-body font-bold text-dark-gray text-base mb-3" data-id="element-479">
                  🔥 80% de descuento — Todo por:
                </p>
                <span className="font-heading font-bold text-5xl sm:text-6xl md:text-7xl text-pink-dark" data-id="element-480">
                  $14
                </span>
              </div>

              {/* CTA Button */}
              <div className="mt-6" data-id="element-481">
                <CTAButton size="large" href="https://www.yennilemon.com/cart/44201631187079:1?country=US&locale=en-US" data-id="element-482">
                  Sí, quiero mis bonos y la guía
                </CTAButton>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}